import { render, staticRenderFns } from "./ProfessorsIndex.vue?vue&type=template&id=0cb611c1"
import script from "./ProfessorsIndex.vue?vue&type=script&lang=js"
export * from "./ProfessorsIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports